/** Mirrors backend shared roles — single source of truth for API role strings. */
export const Roles = {
    Admin: "admin",
    Therapist: "therapist",
    Parent: "parent",
    Secretary: "secretary",
} as const;

export type UserRole = (typeof Roles)[keyof typeof Roles];
